<template>
<div>
  <router-view/>
  </div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #110e0e;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #110e0e;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
